<template>
  <div class="p-login-guidance-modal">
    <ModalDesign ref="login-guidance-modal" width-size="md" @hide="hideModal">
      <div class="modal-box-content">
        <h2 class="title">
          ログインして<br />サービスをご利用ください。
        </h2>

        <div class="btn-wrapper" @click="hideModal()">
          <a :href="redirectUrl" class="c-button c-button__primary c-button__primary--color2">
            ログイン
          </a>
        </div>

      </div>
    </ModalDesign>
  </div>
</template>
<script>
export default {
  props: ["params"],
  methods: {
    hideModal() {
      this.$store.commit("auth/set", { authenticate: false });
      this.$refs["login-guidance-modal"].hide();
      this.deleteQuery("back_uri");
      this.$emit("hide");
    },
    deleteQuery(key) {
      const query = Object.assign({}, this.$route.query);
      delete query[key];
      this.$router.push({ query: query });
    }
  },
  computed: {
    redirectUrl() {
      let backUri = this.$route.query.back_uri;
      if (this.$route.hash) {
        backUri = backUri + this.$route.hash;
      }
      return (
        process.env.VUE_APP_AUTHORIZATION +
        "/v1/stay/login?" +
        encodeURI(backUri)
      );
    }
  },
  mounted() {
    this.$refs["login-guidance-modal"].show();
  }
};
</script>
<style lang="scss" scoped>
.modal-box-content {
  text-align: center;

  .title {
    font-size: 24px;
    line-height: 36px;
    font-weight: bold;
    margin-bottom: 40px;
    @screen sm {
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 25px;
    }
  }

  .btn-wrapper {
    margin-bottom: 30px;
    @screen sm {
      margin-bottom: 15px;
    }

    .c-button {
      border-radius: 4px;
      background: rgba(230, 0, 33, 1);
      color: #fff;
      font-size: 20px;
      line-height: 30px;
      outline: none;
      padding: 10px;
      min-width: 246px;
      min-height: 48px;
      display: inline-block;
      font-weight: bold;
      @screen sm {
        font-size: 13px;
        line-height: 19px;
        padding: 7px 10px 10px 10px;
        min-width: 160px;
        min-height: 37px;
      }
    }
  }
}
</style>
  
